export function getMountContext (targetSelector, contextKey) {
  const target = document.querySelector(targetSelector)

  if (!target || !target.dataset[contextKey]) {
    return {}
  }

  return JSON.parse(target.dataset[contextKey])
}
